import { IVehiclePricingMatrixPart } from "../models/account/IAccountPartPricingMatrix";

// A quote typed into the matrix after the category's part was already made from the Parts tab:
// the parts that would change if they took this account and price. Parts already on both are left
// out, and clearing a cell (no price) never offers to touch a part.
export function partsOutOfStepWithQuote(
  parts: IVehiclePricingMatrixPart[] | undefined,
  accountId: string,
  price: number | null
): IVehiclePricingMatrixPart[] {
  if (price == null) return [];

  return (parts ?? []).filter((part) => part.accountId !== accountId || part.enteredPrice !== price);
}
